import { type InferInsertModel, type InferSelectModel, sql } from 'drizzle-orm';
import {
  boolean,
  pgTable,
  text,
  timestamp,
  uniqueIndex,
  uuid,
} from 'drizzle-orm/pg-core';

import { softDelete } from '../columns/soft-delete';

export const artists = pgTable(
  'artists',
  {
    id: uuid('id')
      .primaryKey()
      .$defaultFn(() => Bun.randomUUIDv7()),
    name: text('name').notNull(),
    isActive: boolean('is_active').default(true),
    createdAt: timestamp('created_at')
      .notNull()
      .$defaultFn(() => new Date()),
    updatedAt: timestamp('updated_at')
      .$onUpdate(() => new Date())
      .notNull(),
    ...softDelete,
  },
  (t) => [
    uniqueIndex('artists_name_unique').on(t.name).where(sql`${t.deletedAt} is null`),
  ],
);

export type Artist = InferSelectModel<typeof artists>;
export type CreateArtistInput = InferInsertModel<typeof artists>;
export type UpdateArtistInput = Partial<CreateArtistInput>;
